import { render, staticRenderFns } from "./GlobalBanner.vue?vue&type=template&id=c5340112"
import script from "./GlobalBanner.vue?vue&type=script&lang=js"
export * from "./GlobalBanner.vue?vue&type=script&lang=js"
import style0 from "./GlobalBanner.vue?vue&type=style&index=0&id=c5340112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports